import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { ROUTES_ARCHIVOS } from '../constants/constant.model';
import { Observable } from 'rxjs';
import { itipoCambio } from '../models/itipoCambio';

@Injectable(
    { providedIn: 'root' }
)
export class MonedaService {

    constructor(private apiService: ApiService) { }

    insertarTipoCambio(data: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.tipo_cambio_insertar_modificar_url);
        return this.apiService.executePostJson(data).pipe();
    }

    actualizarTipoCambio(data: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.tipo_cambio_insertar_modificar_url);
        return this.apiService.executePutJson(data).pipe();
    }

    buscar(): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.moneda_buscar);
        return this.apiService.execGetJson()
    }
    insertMoneda(data: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.moneda_insertar);
        //const fullUrl = `${this.clienteService.getUrlSession().urlService}/tmoneda`;
        return this.apiService.executePostJson(data).pipe();
    }
    actualizarMoneda(data: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.moneda_actualizar);
        //const fullUrl = `${this.clienteService.getUrlSession().urlService}/tmoneda`;
        return this.apiService.executePutJson(data).pipe();
    }
    eliminarMoneda(data: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.moneda_eliminar);
        //const fullUrl = `${this.clienteService.getUrlSession().urlService}/tmoneda`;
        return this.apiService.executeDeleteJson(data).pipe();
    }

}